export class SystemUtils {
  public static formatKeyboardShortcut(shortcut: string | undefined, isMac: boolean) {
    if (!shortcut) {
      return '';
    }

    return shortcut
      .replace(/CmdOrCtrl/gi, isMac ? '⌘' : 'Ctrl')
      .replace(/Alt/gi, isMac ? '⌥' : 'Alt')
      .replace(/Shift/gi, '⇧')
      .replace(/Plus/gi, '+')
      .replace(/\+/g, isMac ? '' : '+');
  }
}
